import { RouteNames } from '@/routes'
import { useEffect } from 'react'
import { useNavigate, useRouteError } from 'react-router-dom'

export function ErrorRoute({ message }: { message?: string }) {
  const navigate = useNavigate()
  const error = useRouteError() as {
    statusText: string
    message: string
  }
  console.error(error ?? message)

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate(RouteNames.Root)
    }, 2000)

    return () => clearTimeout(timer)
  }, [navigate])

  return (
    <div className="flex min-h-full flex-1 flex-col items-center justify-center">
      <h1 className="text-4xl">Oops!</h1>
      <p className="my-2 text-center text-2xl">
        Sorry, an unexpected error has occurred.
      </p>
      <p className="text-xl text-red-600">
        {(error && 'statusText' in error && error.statusText) ||
          (error && 'message' in error && error.message) ||
          message}
      </p>
    </div>
  )
}
